import { useRef as B, useState as G, useMemo as L, useEffect as j, useCallback as d } from "react";
import { m as k } from "../../../libServer-S4LVM0ns.js";
const b = 111320;
function F({
  initialSingleMarker: u,
  randomPosition: a = !1,
  id: p = "1",
  onMoveEnd: o,
  onDragEnd: l,
  onResize: f,
  debounceEventsTime: M = 300,
  ref: s
}) {
  const n = B(null), [m, I] = G(!1), h = L(() => {
    if (!a) return null;
    const t = p.toString();
    let e = 0;
    for (let c = 0; c < t.length; c++)
      e = (e << 5) - e + t.charCodeAt(c), e = e & e;
    return () => {
      const c = Math.sin(e++) * 1e4;
      return c - Math.floor(c);
    };
  }, [a, p]), O = L(() => {
    if (!u) return null;
    if (!a || !h) return u;
    const t = { ...u }, e = h, c = e() * 2 * Math.PI, r = e() * 500, y = r / b * Math.cos(c), A = r / (b * Math.cos(t.latitude * Math.PI / 180)) * Math.sin(c);
    return t.latitude += y, t.longitude += A, t;
  }, [u, a, h]);
  j(() => {
    s && n.current && (typeof s == "function" ? s(n.current) : s.current = n.current);
  }, [s, m]);
  const g = d(
    (t) => {
      t.originalEvent && k(() => {
        var r;
        o == null || o(t, (r = n.current) == null ? void 0 : r.getBounds());
      }, M)();
    },
    [o, M]
  ), x = d(
    (t) => {
      l == null || l(t);
    },
    [l]
  ), C = d(
    (t) => {
      f == null || f(t);
    },
    [f]
  ), H = d(() => {
    I(!0);
  }, []);
  return {
    mapRef: n,
    mapLoaded: m,
    singleMarker: O,
    debouncedOnMoveEnd: g,
    handleDragEnd: x,
    debouncedOnResize: C,
    handleMapLoad: H
  };
}
export {
  b as OneDegreeInMeters,
  F as useMap
};
